import CartIcon from './CartIcon.vue'

export default CartIcon
